<template>
    <div class="sk-slider">
        <div class="sk-slider-title elem"></div>
        <div class="sk-slider-wrapper">
            <div v-for="item in 6" class="sk-slider-elem elem"></div>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style scoped lang="less">
@import "theme/moydom/less/variables.less";

.sk-slider {
    margin-top: 40px;
    overflow: hidden;

    @media (max-width: @screen-sm) {
        margin-top: 20px;
    }

    &-wrapper {
        display: flex;
        gap: 30px;

        @media (max-width: @screen-sm) {
            gap: 15px;
        }
    }

    &-title {
        width: 161px;
        height: 20px;
        margin-bottom: 15px;
        display: none;

        @media (max-width: @screen-sm) {
            display: block;
        }
    }

    &-elem {
        flex-shrink: 0;
        width: 200px;
        height: 200px;

        @media (max-width: @screen-sm) {
            width: 160px;
            height: 160px;
        }
    }
}

.elem {
    border-radius: 8px;
    background: #e7e7e7;
    position: relative;
    overflow: hidden;

    &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transform: translateX(-100%);
        background: linear-gradient(90deg,
        transparent 0%,
        #c3c3c361 30%,
        transparent 100%);
        animation: load 2s infinite;
        content: '';
    }
}

@keyframes load {
    100% {
        transform: translateX(100%);
    }
}

</style>
